import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export interface TableColumn {
  header: string;
  field: string;
}

/**
 * A read-only data table.
 *
 * No ng-primitives equivalent, and none needed: there is no sorting,
 * selection or cell-level focus here, so a plain semantic <table> with
 * scoped headers gives screen readers correct row/column association on
 * its own.
 *
 * Intentionally unstyled.
 */
@Component({
  selector: 'hh-data-table',
  standalone: true,
  template: `
    <table class="hh-data-table">
      <thead>
        <tr>
          @for (col of columns(); track col.field) {
            <th scope="col">{{ col.header }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of data(); track $index) {
          <tr>
            @for (col of columns(); track col.field) {
              <td>{{ row[col.field] }}</td>
            }
          </tr>
        }
      </tbody>
    </table>
  `,
  styleUrl: './hh-data-table.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HhDataTableComponent {
  readonly columns = input<TableColumn[]>([]);
  readonly data = input<Record<string, unknown>[]>([]);
}
